module.exports = __webpack_public_path__ + "static/media/robot.8685a840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameProgramRobot/robot.png
// module id = 2449
// module chunks = 0